import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ErrorLogsComponent } from './error-logs.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { VaFilterModule, VaSearchBoxModule } from '@vendasta/uikit';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatExpansionModule } from '@angular/material/expansion';
import { FilterModule } from '@vendasta/va-filter2';
import { RouterModule, Routes } from '@angular/router';
import { LexiconModule } from '@galaxy/lexicon';
import baseTranslation from '../../../assets/i18n/en_devel.json';
import { WEBLATE_COMPONENT_NAME } from '../../constants';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

const routes: Routes = [
  {
    path: '',
    component: ErrorLogsComponent,
  },
];

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    RouterModule.forChild(routes),
    TranslateModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
    MatButtonToggleModule,
    VaFilterModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
    MatExpansionModule,
    VaFilterModule,
    FilterModule,
    VaSearchBoxModule,
    GalaxyPageModule,
    MatIconModule,
    MatButtonModule,
  ],
  declarations: [ErrorLogsComponent],
  exports: [RouterModule],
  providers: [],
})
export class ErrorLogsModule {}
